import React, {useEffect, useMemo} from 'react';
import CustomModal from "../../../components/UI/CustomModal";
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import {
    Btn,
    EllipsisText,
    FlexColumnSection,
    FlexSection,
    Header,
    SmallHeader
} from "../../../styles/globalStyles";
import dayjs from "dayjs";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import '../../../components/UI/UI.scss';
import {t} from "i18next";
import {useDispatch, useSelector} from "react-redux";
import {membershipTypes} from "@arboxappv4/shared/src/helpers/constants";
import {getBoxPageOptions, onLinkClicked} from "../../../helpers/functions";
import {useNavigate} from "react-router-dom";
import {getPayForSlotMembershipType, getTrialMembershipType} from "@arboxappv4/shared/src/helpers/functions";
import CustomCollapse from "../../../components/UI/CustomCollapse";
import {DB_DATE_FORMAT} from "@arboxappv4/shared/src/constants/constants";
import {updateError, updateFlags} from "@arboxappv4/shared/src/redux/stepperSlice";
import SessionFullInfo from "../../../components/SessionFullInfo";
import {apiAction} from "@arboxappv4/shared/src/helpers/HTTP";

const SessionMembershipSelect = (props) => {
    const { isOpen, onClose, session, title, onMembershipSelect, ignoreDisabledPages, hidePayableOptions } = props;
    const loggedIn = useSelector(state => state.auth.loggedIn)
    const box = useSelector(state => state.site.box)
    const memberships = useSelector(state => state.user.memberships)
    const globalLocation = useSelector(state => state.site.selectedLocation)
    const flags = useSelector(state => state.stepper.flags)
    const userBox = useSelector(state => state.user.activeUsersBoxes)

    const {isMobile} = useScreenSize();
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const hasMembershipPage = useMemo(() => box ? getBoxPageOptions().hasMemberships : false, [box])
    const payForSlot = useMemo(() => session && !hidePayableOptions ? getPayForSlotMembershipType(session) : null, [session, hidePayableOptions])
    const trial = useMemo(() => (session && !loggedIn && !hidePayableOptions) ? getTrialMembershipType(session) : null, [session, hidePayableOptions])
    const currencySymbol = useMemo(() => globalLocation?.currency_symbol, [globalLocation]);

    // useEffect(() => {
    //     if(flags.stepsUpdated && loggedIn) {
    //         console.log('hi')
    //         dispatch(updateFlags({payForSlot: null, stepsUpdated: false})) // if not logged in- steps are always ready, if logged in- turn flag back off
    //         onClose()
    //     }
    // }, [flags.stepsUpdated]);

    const goToMembership = () => {
        onLinkClicked('/membership', navigate)
        onClose()
    }

    const getMembershipInfo = (membership) => {
        return (
            <FlexSection mobile={isMobile} justify={isMobile ? 'start' : membership.active === 2 ? 'space-between' : 'end'}>
                {membership.active === 2 && <span>{t('future-start-date')} {dayjs(membership.start, DB_DATE_FORMAT).format(session.locations_box.date_format)}</span>}
                <EllipsisText width={isMobile ? 'auto' : '160px'}>
                    {membership.type === membershipTypes.TRIAL && <span>{membership.price > 0 ? `${currencySymbol} ${membership.price}` : t('free')}</span>}
                    {membership.type === membershipTypes.PAY_FOR_SLOT && <span>{currencySymbol} {membership.price}</span>}
                    {membership.mt_type === membershipTypes.PLAN && <span>{membership.end ? `${t('membership-end-date')} ${dayjs(membership.end, DB_DATE_FORMAT).format(session.locations_box.date_format)}` : t('no-end-date')}</span>}
                    {membership.mt_type === membershipTypes.PUNCH_CARD && <span>{t('left-sessions', {num: membership.sessions_left})}</span>}
                </EllipsisText>
            </FlexSection>
        )
    }

    const membershipSelected = async (membership, payForSlot) => {
        try {
            if ((payForSlot && membership.type === membershipTypes.PAY_FOR_SLOT) ||  membership.type === membershipTypes.TRIAL) {
                await apiAction('checkUserPayForSlotLimitations', 'post', {ub_id: userBox?.ub_id, schedule_id: session.availability ? null : session.id, membership_type_id: membership.id});
            }
            onMembershipSelect({payForSlot: payForSlot, id: membership.id, trial: membership.type === membershipTypes.TRIAL})
            dispatch(updateFlags({payForSlot, session: session}))
            onClose()
        } catch (error) {
            dispatch(updateError(error.error.messageToUser))
            onClose()
        }
    }

    return (
        <CustomModal open={isOpen}
                     onClose={onClose}
                     width={isMobile ? 'inherit' : '800px'}
                     title={<Header>{title}</Header>}
                     style={{body: {overflow: 'auto', height: isMobile ? 'calc(100% - 45px)' : 'auto'}}}
        >
            <FlexColumnSection gap={'15px'}>
            <FlexColumnSection gap={'8px'}>
                <SessionFullInfo session={session} ignoreDisabledPages={ignoreDisabledPages}/>
                
                {session.box_categories.bio && (
                    <FlexColumnSection gap={'6px'}>
                        <SmallHeader fontSize={'16px'} weight={'bold'}>{t('description')}:</SmallHeader>
                        <div style={{flex: 1, whiteSpace: 'pre-wrap'}}>{session.box_categories.bio}</div>
                    </FlexColumnSection>
                        )}
                        </FlexColumnSection>
                <FlexColumnSection gap={'5px'}>
                    <SmallHeader>{t('select-membership-header')}</SmallHeader>
                    {(memberships && memberships.length > 0) || payForSlot || trial ?
                        <FlexColumnSection gap={'5px'} overflow={isMobile ? 'hidden' : 'hidden auto'} maxHeight={isMobile ? 'auto' : '210px'}>
                            {trial &&
                                <CustomCollapse headerText={t('trial-class', {interpolation: {'escapeValue': false}})}
                                                disableExpand={'icon'}
                                                ctaText={t('trial-select-btn')}
                                                headerWidth={'auto'}
                                                headerInfo={getMembershipInfo(trial)}
                                                onBtnClick={() => membershipSelected(trial, true)}
                                                background={Colors.siteBg}
                                />}
                            {payForSlot &&
                            <CustomCollapse headerText={t('pay-for-type', {type: payForSlot.name, interpolation: {'escapeValue': false}})}
                                            disableExpand={'icon'}
                                            ctaText={t('pay-for-slot-select-btn')}
                                            headerWidth={'auto'}
                                            headerInfo={getMembershipInfo(payForSlot)}
                                            onBtnClick={() => membershipSelected(payForSlot, true)}
                                            background={Colors.siteBg}
                            />}
                            {memberships?.map(membership => (
                                <CustomCollapse headerText={membership.membership_types.name}
                                                disableExpand={'icon'}
                                                ctaText={t(`${session.booking_option}-select-btn`)}
                                                headerWidth={'auto'}
                                                headerInfo={getMembershipInfo(membership)}
                                                onBtnClick={() => membershipSelected(membership, false)}
                                                background={Colors.siteBg}
                                                key={`user-membership-${membership.id}`}
                                />
                            ))}
                        </FlexColumnSection>
                        :
                        <FlexColumnSection gap={'15px'}>
                            <span>{hasMembershipPage ? t('no-memberships-label') : t('no-memberships-to-purchase')}</span>
                            {hasMembershipPage && <Btn type={'primary'} onClick={goToMembership}>{t('purchase-membership')}</Btn>}
                        </FlexColumnSection>
                    }
                </FlexColumnSection>
            </FlexColumnSection>
        </CustomModal>
    );
};

export default SessionMembershipSelect;
